module.exports = __webpack_public_path__ + "static/media/wedding.44dd318c.png";